import React from 'react'

import './styles.scss'

const DotsButton = ({ orientation = 'horizontal', color, onClick, className }) => (
  <button className={`dots-button dots-button--${orientation} ${className || ''}`} onClick={onClick}>
    <div style={{ backgroundColor: color || null }}></div>
    <div style={{ backgroundColor: color || null }}></div>
    <div style={{ backgroundColor: color || null }}></div>
  </button>
)

export default DotsButton
